module.exports = __webpack_public_path__ + "img/Archiv_2022.048a0e64.jpeg";